import cachedFirestore from "../cachedFirestore";
import {
  menuCommunityBtnEl,
  replayFavIconEl,
  replayFiveStarReviewBtnEl,
  replayFourStarReviewBtnEl,
  replayOneStarReviewBtnEl,
  replayThreeStarReviewBtnEl,
  replayTwoStarReviewBtnEl,
} from "../elements";
import { addTouchEvent } from "../events";
import { stack } from "../nav";
import store from "../store";
import { levelDef } from "../game/gameState";
import { closeMenu } from "../menu";
import { removeFavorite, storeFavorite } from ".";

const reviewBtns = [
  replayOneStarReviewBtnEl,
  replayTwoStarReviewBtnEl,
  replayThreeStarReviewBtnEl,
  replayFourStarReviewBtnEl,
  replayFiveStarReviewBtnEl,
];

let starsGlob = null;
let favoriteGlob = false;

export const communityLevelWonAddReviewBtns = (stars) => () => {
  starsGlob = stars + 1;
  reviewBtns.forEach((btn, i) => {
    if (i <= stars) btn.classList.add("replay-star-review-filled");
    else btn.classList.remove("replay-star-review-filled");
  });
  store.communityLevelsRatings[levelDef.id] = stars;
  store.save("communityLevelsRatings");
};

export const communityLevelWonToggleFavorite = () => {
  if (replayFavIconEl.classList.contains("outlined")) {
    if (storeFavorite(levelDef.id)) {
      replayFavIconEl.classList.remove("outlined");
      favoriteGlob = true;
    }
  } else {
    replayFavIconEl.classList.add("outlined");
    favoriteGlob = false;
    removeFavorite(levelDef.id);
  }
};

export const submitLevelWonReviewData = () => {
  reviewBtns.forEach((btn) => {
    if (btn.classList.contains("replay-star-review-filled"))
      btn.classList.remove("replay-star-review-filled");
  });
  cachedFirestore.setDocument({
    reference: `communityLevels/${levelDef.id}/player/${store.user.uid}`,
    data: {
      rating: starsGlob,
      favorite: favoriteGlob,
      uid: store.user.uid,
      steps: store.step,
      won: true,
    },
  });
  if (!replayFavIconEl.classList.contains("outlined"))
    replayFavIconEl.classList.add("outlined");
  starsGlob = null;
  favoriteGlob = false;
};

export function setFavorite(favorite) {
  favoriteGlob = favorite;
  starsGlob = null;
}

addTouchEvent(menuCommunityBtnEl, () => {
  stack.reset();
  stack.push("community_feed");
  closeMenu();
});
